/* Project Import will be here */
import { getErrorObject, getSuccessObject, errorToast } from "utilities/utils";
import {
    getGenerateComplaintsMetaDataApi,
    generateNewComplaintApi
} from "services/complaints";
import { IGenerateComplaintModel } from "models/complaintModels";
import Constants from "utilities/appConstants";
import { forEach } from "lodash";
import { showMsgFromJson } from "reducers/common";
import { GAProductComplaint } from "hooks/googleAnalyticsHooks";
/* Project Import will be here */

export const types = {
    GENERATE_COMPLAINT_META_REQUEST: "generateComplaints/generateComplaintsMetaRequest",
    GENERATE_COMPLAINT_META_SUCCESS: "generateComplaints/generateComplaintsMetaSuccess",
    GENERATE_COMPLAINT_META_FAILURE: "generateComplaints/generateComplaintsMetaFailure",
    GENERATE_NEW_COMPLAINT_REQUEST: "generateComplaints/generateNewComplaintRequest",
    GENERATE_NEW_COMPLAINT_RESPONSE: "generateComplaints/generateNewComplaintRESPONSE"
};

let initialState = {
    isLoadingGenerateNewComplaint: false,
    isLoading: false,
    data: {},
    error: null
};

export const generateComplaints = (state = initialState, action) => {
    switch (action.type) {
        case types.GENERATE_COMPLAINT_META_REQUEST:
            return { ...state, isLoading: true };
        case types.GENERATE_COMPLAINT_META_SUCCESS:
            return { ...state, ...action.payload, error: null, isLoading: false };
        case types.GENERATE_COMPLAINT_META_FAILURE:
            return { ...state, isLoading: false, error: action.payload.error };
        case types.GENERATE_NEW_COMPLAINT_REQUEST:
            return { ...state, isLoadingGenerateNewComplaint: true };
        case types.GENERATE_NEW_COMPLAINT_RESPONSE:
            return { ...state, isLoadingGenerateNewComplaint: false };
        default:
            return state;
    }
};

/* Get complaint list to show in the card */
export const getGenerateComplaintsMetaData = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.GENERATE_COMPLAINT_META_REQUEST });
        try {
            const response = await getGenerateComplaintsMetaDataApi();

            /* Extract the API response */
            const responseData = {
                ComplaintReasons: [],
                ComplaintTypes: [],
                DisposalMethods: [],
                ReturnTo: []
            };
            forEach(response.data.Data, (item) => {
                if (item.Type === Constants.COMPLAINT_TYPE)
                    responseData.ComplaintTypes.push(item);
                else if (item.Type === Constants.COMPLAINT_REASON)
                    responseData.ComplaintReasons.push(item);
                else if (item.Type === Constants.COMPLAINT_DISPOSAL_METHOD)
                    responseData.DisposalMethods.push(item);
                else if (item.Type === Constants.COMPLAINT_RETURN_TO)
                    responseData.ReturnTo.push(item);
            });

            dispatch({
                type: types.GENERATE_COMPLAINT_META_SUCCESS,
                payload: { data: responseData }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.GENERATE_COMPLAINT_META_FAILURE,
                payload: { error: message }
            });
        }
    }
};

/* Save new complaint */
export const generateNewComplaint = (data: IGenerateComplaintModel, skuName: string, responseCallback: any) => {
    return async (dispatch, getState) => {
        dispatch({ type: types.GENERATE_NEW_COMPLAINT_REQUEST });
        try {
            const response = await generateNewComplaintApi(data);

            dispatch({ type: types.GENERATE_NEW_COMPLAINT_RESPONSE });

            /* Extract the error message and error code from the response object */
            const { successCode } = getSuccessObject(response);
            /* If success code is exist show the success code message or show the api response message returned by the API request */
            if (successCode !== "")
                dispatch(showMsgFromJson(`common.alerts.success.${successCode}`, Constants.SUCCESS));
            else
                dispatch(showMsgFromJson(`common.alerts.success.generateComplaintSuccess`, Constants.SUCCESS));

            /* Close the generate complaint screen only if the complaint saved successfully */
            responseCallback(false);

            /* GA - track complaint */
            if (window.isEnableGA)
                GAProductComplaint(data, skuName);
        }
        catch (error) {
            /* Extract the error message and error code from the response object */
            const { message, errorCode } = getErrorObject(error);

            dispatch({ type: types.GENERATE_NEW_COMPLAINT_RESPONSE });

            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};